import React from 'react';
import {Redirect} from 'react-router-dom';
import {FuseUtils} from '@fuse/index';
import {ExampleConfig} from 'main/content/example/ExampleConfig';
import {LoginConfig} from 'main/content/login/LoginConfig';
import {pagesConfigs} from 'main/content/pages/pagesConfigs';
import {systemConfigs} from 'main/content/system/SystemConfigs';
import {salesConfigs} from 'main/content/sales/salesConfigs';
import {crmRouterConfigs} from 'main/content/crm/crmRouterConfigs';
import {UnauthorizedPageConfig} from 'main/content/unauthorizedPage/UnauthorizedPageConfig';
import {AdminDashboardAppConfig} from 'main/content/apps/dashboards/AdminDashboardAppConfig';
import {InventoryConfig} from 'main/content/inventory/inventoryRoutesConfig';
import {hrConfigs} from 'main/content/hr/hrConfigs';
import {accountConfigs} from 'main/content/accounting/AccountConfigs';
import {ReportConfig} from 'main/content/report/reportRoutesConfig';
import {AccountingReportsConfig} from 'main/content/accountingReports/AccountingReportsConfig';

const routeConfigs = [
    UnauthorizedPageConfig,
    ...pagesConfigs,
    ...systemConfigs,
    ...salesConfigs,
	...crmRouterConfigs,
    ...InventoryConfig,
    ...hrConfigs,
    ...accountConfigs,
    ...ReportConfig,
    ...AccountingReportsConfig,
    ExampleConfig,
    LoginConfig,
    AdminDashboardAppConfig 
];

export const routes = [
    ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
    {
        path     : '/',
        component: () => <Redirect to="/apps/dashboards/admin"/>
    }
];



// WEBPACK FOOTER //
// ./src/fuse-configs/fuseRoutesConfig.js